import { Component, HostListener, Input } from '@angular/core';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'shared-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  @Input() icons: any = {};

  menuOpen = false;
  logoVisible = true;

  toggleMenu() {
    this.menuOpen = true;
    if (window.innerWidth <= 768) {
      this.logoVisible = false;
    }
  }

  closeMenu() {
    this.menuOpen = false;
    if (window.innerWidth <= 768) {
      this.logoVisible = true;
    }
  }

  goToPortal() {
    window.location.href = environment.portalUrl;
  }
}
